import React from 'react';
import './ApiDetails.css';
import RedirectURL from '../common/RedirectURL';
import moment from 'moment';
import { IconOpenInNew } from 'cdk-radial';
import { APIDetailsHeader } from '../common/ApiDetailsTabHeader';

const renderNoDocumentationTxt = () => {
  return (
    <div>
      <div className="api-dir-pkg_no-documentation-text">
        The provider does not have any documentation available at this time.
      </div>
    </div>
  );
};

const ApiDocumentation = props => {
  return (
    <div>
      <APIDetailsHeader title="API Documentation" />
      {props.auth.isAuthenticated ? (
        props.apiInfo &&
          props.apiInfo.data &&
          props.apiInfo.data.externalDocs &&
          props.apiInfo.data.externalDocs.length ? (
          props.apiInfo.data.externalDocs.map((doc, index) => {
            return (
              <>
                <RedirectURL
                  classes="api-dir-pkg_api-doc-name api-dir-pkg_api-redirect api-dir-pkg_terms-and-agreements"
                  key={index}
                  url={doc.urlLink ? doc.urlLink : doc.url}
                  heading={doc.name}
                  icon={
                    <IconOpenInNew
                      height={16}
                      width={16}
                      className='api-dir-pkg_icon'
                    />
                  }
                />
                <div className="api-dir-pkg_updated-date">
                  Updated:{' '}
                  {moment(doc.lastUpdated)
                    .utc()
                    .format('DD MMM YYYY hh:mm A')}
                </div>
              </>
            );
          })
        ) : (
          renderNoDocumentationTxt()
        )
      ) : (
        <div>
          <div className="api-dir-pkg_no-documentation-text">
            <a
              className="api-dir-pkg_cursor-pointer"
              onClick={() => {
                props.auth.login();
              }}
            >
              Sign in
            </a>{' '}
            to view documentation.
          </div>
        </div>
      )}
    </div>
  );
};

export default ApiDocumentation;
